import { Building2, ClipboardList, ListTodo } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const organizationItems = [
  {
    path: '/organization/surveys',
    label: 'Ankiety',
    icon: ClipboardList,
    description: 'Wypełnij ankiety lub zobacz wyniki',
    requiresPermission: 'survey:fill|survey:view_results|survey:manage'
  },
  {
    path: '/organization/tasks',
    label: 'Zadania i projekty',
    icon: ListTodo,
    description: 'Organizacje, zadania zespołowe i osobiste',
    requiresPermission: 'tasks:use'
  }
];

const Organization = () => {
  const { hasPermission } = useAuth();

  // Filter organization items based on permissions
  const filteredItems = organizationItems.filter(item => {
    if (item.requiresPermission) {
      // Check if permission contains OR operator (|)
      if (item.requiresPermission.includes('|')) {
        const permissions = item.requiresPermission.split('|');
        return permissions.some(perm => hasPermission(perm.trim()));
      }
      return hasPermission(item.requiresPermission);
    }
    return true;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <h2 className="module-page-title"><Building2 aria-hidden="true" /> Organizacja</h2>
        <p>Narzędzia i zasoby informacyjne dotyczące całej firmy</p>
      </div>
      
      <div className="page-content">
        <div className="tiles-grid">
          {filteredItems.map((item) => {
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className="tile-card module-tile">
              <span className="tile-icon module-tile-icon" aria-hidden="true"><Icon strokeWidth={1.8} /></span>
              <h3 className="tile-title">{item.label}</h3>
              <p className="tile-description">{item.description}</p>
            </Link>;
          })}
        </div>
      </div>
    </div>
  );
};

export { organizationItems };
export default Organization;
